import { combineReducers } from "redux";

import auth from "redux/reducers/auth";
import chats from "redux/reducers/chats";

export default combineReducers({
  auth,
  chats,
});
